import { AdjustmentReasonEntity } from '../../domain/entities/AdjustmentReasonEntity'

export class CreateUpdateAdjustmentReasonModel extends AdjustmentReasonEntity {
  declare name: string

  constructor(dataDto: AdjustmentReasonEntity) {
    super()
    this.name = dataDto.name ?? ''
  }
}
